import AuthService, { TOKEN_KEY } from "../services/auth.service";

export const fetchWrapper = {
  get: request("GET"),
  post: request("POST"),
  patch: request("PATCH"),
  put: request("PUT"),
  delete: request("DELETE"),
  upload: request("POST"),
};

function request(method) {
  return async (url, body) => {
    const requestOptions = { method, headers: authHeader() };
    if (body) {
      if (body?.hasFile) {
        requestOptions.body = createFormData(body);
      } else {
        requestOptions.headers["Content-Type"] = "application/json";
        requestOptions.body = JSON.stringify(body);
      }
    }
    return fetch(url, requestOptions)
      .then(handleResponse)
      .catch((err) => {
        const errorMessage =
          typeof err === "string"
            ? err
            : err?.message || err?.error || "Error de conexión con el servidor";

        return Promise.reject(errorMessage);
      });
  };
}

function authHeader() {
  const token = localStorage.getItem(TOKEN_KEY);
  return !!token ? { Authorization: `Bearer ${token}` } : {};
}

async function handleResponse(response) {
  const isJson = response.headers
    ?.get("content-type")
    ?.includes("application/json");

  const text = await response.text();
  const data = isJson && text ? JSON.parse(text) : null;

  if (!response.ok) {
    if ([401].includes(response?.status)) {
      console.log("Cierre de sesión automático");
      AuthService.removeSession();
    }

    const error =
      (data &&
        (typeof data.error === "string"
          ? data.error
          : data.error?.message || data.message)) ||
      response.statusText ||
      "Error en el servidor";

    return Promise.reject(error);
  }

  return data;
}

function createFormData(object) {
  const formData = new FormData();
  Object.keys(object).forEach((key) => {
    if (key !== "hasFile" && key !== "withoutLoading") {
      formData.append(key, object[key]);
    }
  });
  return formData;
}
